import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import style from "./style.module.scss"
import InputSearch from "../../shared/forms/input-search";
import OrdersLocationDropdownItem from "./OrdersLocationDropdownItem";
import OrdersLocationAddModal from "./OrdersLocationAddModal";
import OrdersLocationGroup from "./OrdersLocationGroup";
import {Order} from "../../../services";
import {toast} from "react-toastify";
import Loading from "../../shared/Loading/Loading";
import { t } from "i18next";

const OrdersLocationDropdown = ({
  onClose,
  clickHandle,
  isSender = false,
  isIntermediatePoint = false,
  countries = [],
  countrySelected,
  onChangeCity,
  onChangeCountry,
  citySelected
}) => {
  const [searchText, setSearchText] = useState(null)
  const [items, setItems] = useState([])
  const [isLoading, setLoading] = useState(false)
  const [displayModal, changeModal] = useState(false)
  const $rootEl = useRef(null)

  const stopClickParent = e => {
    e.stopPropagation()
  }

  const onClickOutSite = useCallback(() => {
    // onClose()
  }, []);

  useEffect(() => {
    $rootEl.current.focus()
    fetchData()
  }, [])

  const itemsFound = useMemo(() => {
    return items.filter(i =>
      (i.name?.toLowerCase().includes(searchText)
      || i.phoneNumber?.toLowerCase().includes(searchText)
      || i.fullAddress?.toLowerCase().includes(searchText)
      || i.email?.toLowerCase().includes(searchText))
      && i.cityId === citySelected?.id
    )
  }, [items, searchText, citySelected])

  const fetchData = () => {
    setLoading(true)
    const type = isIntermediatePoint ? null : isSender ? 0 : 1;
    Order.getUserAddress({ type })
      .then(({ data }) => {
        setItems(data);
      })
      .catch((error) => {
        toast.error(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const itemsFilteredByCountryAndCity = useMemo(() => {
    return items.filter(i => i.cityId === citySelected?.id || i.countryId === countrySelected?.id && i.cityId === citySelected?.id)
  }, [items, citySelected])

  const itemsGroups = useMemo(() => {
    const groups = {}
    const withOutGroups = []
    itemsFilteredByCountryAndCity.forEach(i => {
      if (!i.name) {
        withOutGroups.push(i)
      } else {
        if (!groups[i.name]) {
          groups[i.name] = []
        }
        groups[i.name].push(i)
      }
    })
    const groupsItems = []
    for (const groupName in groups) {
      groupsItems.push({
        name: groupName,
        isGroup: true,
        children: groups[groupName]
      })
    }
    return [...withOutGroups, ...groupsItems]
  }, [itemsFilteredByCountryAndCity])

  const pushItem = obj => {
    setItems([...items, obj])
    changeModal(false)
    clickHandle(obj)
  }

  const removeItem = deleted => {
    setItems(prev => prev.filter(i => i.id !== deleted.id))
  }

  const replaceItem = updated => {
    setItems(prev => prev.map(i => (i.id === updated.id ? { ...i, ...updated } : i)))
  }

  const renderItem = item => (
    <OrdersLocationDropdownItem
      key={item.id}
      item={item}
      clickHandle={clickHandle}
      isSender={isIntermediatePoint ? item.type === 0 : isSender}
      onDeleted={removeItem}
      onUpdated={replaceItem}
    />
  )

  return (
    <div ref={$rootEl} className={style.dropdown} onClick={stopClickParent} onBlur={onClickOutSite} tabIndex={1}>
      <h3 className={style.dropdown_title}>
        { isSender ? t("addressOrder.chooseLoadingAddress") : t("addressOrder.chooseRecipient")}
      </h3>
      {itemsGroups.length > 0 && <InputSearch onGetText={setSearchText} />}
      <div className={style.dropdown_content}>
        { isLoading && <Loading inBlock /> }
        {
          searchText
          ? itemsFound.map(renderItem)
          : (
              itemsGroups.map((item, idx) =>
                item.isGroup
                ? <OrdersLocationGroup key={'local-group-' + idx} item={item}>
                    {item.children.map(renderItem)}
                  </OrdersLocationGroup>
                : renderItem(item)
              )
            )
        }
      </div>


      <button type="button" className={style.dropdown_button} onClick={() => changeModal(!displayModal)}>
        { isSender ? t("addressOrder.addAddress") : t("addressOrder.addRecipientAddress")}
      </button>

      {displayModal && <OrdersLocationAddModal
        onClose={() => changeModal(false)}
        updateContent={pushItem}
        titleEnd={isSender ? t("addressOrder.sender") : t("addressOrder.recipient")}
        countries={countries}
        displayBin={!isSender}
        isSender={isSender}
        searchText={searchText}
        countrySelected={countrySelected}
        citySelected={citySelected}
        onChangeCountry={onChangeCountry}
        onChangeCity={onChangeCity}
      />}
    </div>
  );
};

export default OrdersLocationDropdown;
